module.exports = __webpack_public_path__ + "static/media/_default-img.8d30aae8.svg";